export enum IconsEnum {
    ADD_FILE = 'addFile',
    AI = 'ai',
    APPROVED = 'approved',
    APPROVED_OUTLINE = 'approvedOutline',
    ARROW_DOWN = 'arrowDown',
    ARROW_DOWN_LEFT = 'arrowDownLeft',
    ARROW_DOWN_RIGHT = 'arrowDownRight',
    ARROW_LEFT = 'arrowLeft',
    ARROW_RIGHT = 'arrowRight',
    ARROW_UP = 'arrowUp',
    ARROW_UP_LEFT = 'arrowUpLeft',
    ARROW_UP_RIGHT = 'arrowUpRight',
    BACK_ARROW = 'backArrow',
    BAR_CHART = 'barChart',
    BELL = 'bell',
    BIN = 'bin',
    BIN_DELETE = 'binDelete',
    BOOKMARK = 'bookmark',
    BUILDING = 'building',
    BULB = 'bulb',
    CALCULATOR = 'calculator',
    CAMERA = 'camera',
    CANCEL = 'cancel',
    CANCEL_CIRCLE = 'cancelCircle',
    CHAT = 'chat',
    CHECK = 'check',
    CHECK_CIRCLE = 'checkCircle',
    CHECKBOX = 'checkbox',
    CHECKBOX_CHECKED = 'checkboxChecked',
    CHEVRON_DOWN = 'chevronDown',
    CHEVRON_LEFT = 'chevronLeft',
    CHEVRON_RIGHT = 'chevronRight',
    CHEVRON_UP = 'chevronUp',
    CLICKED = 'clicked',
    CLOSE = 'close',
    COMMENT = 'comment',
    COPY = 'copy',
    DASH = 'dash',
    DOCUMENT_INCOMPLETE = 'document_incomplete',
    DOLLAR_CIRCLED = 'dollarCircled',
    DOWNLOAD = 'download',
    EDIT = 'edit',
    ELLIPSIS_HORIZONTAL = 'ellipsisHorizontal',
    ELLIPSIS_VERTICAL = 'ellipsisVertical',
    EYE_CLOSED = 'eyeClosed',
    EYE_OPEN = 'eyeOpen',
    FEMALE = 'female',
    FILTER = 'filter',
    GLOBE = 'globe',
    HAMBURGER_MENU = 'hamburgerMenu',
    HEART_FILLED = 'heartFilled',
    HEART_OUTLINE = 'heartOutline',
    HOME_PIN = 'homePin',
    IDEA_BULB = 'ideaBulb',
    IMAGE_PRELOADER = 'imagePreloader',
    LIKE = 'like',
    LINK = 'link',
    MALE = 'male',
    MEGAPHONE = 'megaphone',
    MESSAGES = 'messages',
    MODERATE_HISTORY = 'moderate_history',
    NO_VIDEO = 'noVideo',
    NOT_FOUND = 'notFound',
    OFFICES = 'offices',
    PADLOCK = 'padlock',
    PADLOCK_UNLOCKED = 'padlockUnlocked',
    PEOPLE = 'people',
    PERSON_ADD = 'person_add',
    PERSON_REMOVE = 'person_remove',
    PERSON_QUESTION = 'person_question',
    PIN_FILLED = 'pinFilled',
    PIN_OUTLINE = 'pinOutline',
    PLASTER = 'plaster',
    PLUS = 'plus',
    POST_ARROW = 'postArrow',
    PROFILE = 'profile',
    PROFILE_PICTURE = 'profile_picture',
    QUESTION_CIRCLE = 'question_circle',
    RADIO_CHECKED = 'radioChecked',
    RADIO_UNCHECKED = 'radioUnchecked',
    REFRESH = 'refresh',
    REVERT = 'revert',
    REVIEW = 'review',
    SEARCH = 'search',
    SETTINGS = 'settings',
    SHARE = 'share',
    SOCIAL_INSTAGRAM = 'socialInstagram',
    SOCIAL_RED_NOTE = 'socialRednote',
    SOCIAL_SNAPCHAT = 'socialSnapchat',
    SOCIAL_TIKTOK = 'socialTiktok',
    SOCIAL_TIKTOK_ICON = 'social_tiktok_icon',
    SOCIAL_YOUTUBE = 'socialYoutube',
    SOCIAL_WHATSAPP = 'socialWhatsApp',
    SORT = 'sort',
    SORT_ASC = 'sortAsc',
    SORT_DESC = 'sortDesc',
    SPARKLE = 'sparkle',
    STAR = 'star',
    SUITCASE = 'suitcase',
    THEATRE_MASKS = 'theatre_masks',
    TRENDING_DOWN = 'trending_down',
    TRENDING_UP = 'trending_up',
    UNHAPPY_FACE = 'unhappyFace',
    UPLOAD = 'upload',
    WARNING = 'warning',
    VIDEO = 'video',
    VIDEO_PLAY = 'video_play',
    VIDEO_PAUSE = 'video_pause',
    VIDEO_FULL_SCREEN = 'video_full_screen',
    VIDEO_SMALL_SCREEN = 'video_small_screen'
}

export interface IconModel {
    name: IconsEnum;
    size: number;
    viewBox?: string;
    class?: string;
    fill?: string;
}